import React from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import LiveChat from "../section-component/live-chat/LiveChat";
import BlogCard from "./blog-card/BlogCard";
import FeaturedBlog from "./feature-blog/FeaturedBlog";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const BlogsIndex = () => {
    return (
        <>
        
 
            <BlogCard />
            {/* <CategoryFilter /> */}
            
            {/* <FeaturedBlog /> */}
        
        </>
    );
};

export default BlogsIndex;